import { Language } from '@/contexts/LanguageContext';

// Centralized API endpoint mapping for Turkish and English
export const API_ENDPOINTS = {
    HOME: {
        TR: '/anasayfa',
        EN: '/home',
    },
    PROPERTIES: {
        TR: '/emlaklar',
        EN: '/properties',
    },
    PROPERTY_DETAIL: {
        TR: '/emlak-detay',
        EN: '/property-detail',
    },
    BLOG: {
        TR: '/blog',
        EN: '/blogs',
    },
    ABOUT: {
        TR: '/hakkimizda',
        EN: '/hakkimizda-Eng',
    },
    CONTACT: {
        TR: '/iletisim',
        EN: '/contact',
    },
    AREA_GUIDE: {
        TR: '/alan-rehberi',
        EN: '/area-guide',
    },
    BUYER_GUIDE: {
        TR: '/alici-rehberi',
        EN: '/buyer-guide',
    },
    LEGAL: {
        TR: '/kurumsal',
        EN: '/terms-policies',
    },
    LAYOUT: {
        TR: '/layout',
        EN: '/header-footer',
    },
} as const;

/**
 * Get the language-specific endpoint for a given base path
 * @param path - The current path (can be TR or EN version)
 * @param language - The target language
 * @returns The language-specific endpoint
 */
export const getLanguageEndpoint = (path: string, language: Language): string => {
    // If path is empty or just '/', return as is
    if (!path || path === '/') return path;

    // Remove leading slash for comparison
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;

    // Extract the base path (first segment) and remaining path
    const segments = cleanPath.split('/');
    const basePath = '/' + segments[0];
    const remainingPath = segments.length > 1 ? '/' + segments.slice(1).join('/') : '';

    // Check each endpoint mapping
    for (const [key, endpoints] of Object.entries(API_ENDPOINTS)) {
        // Check if the base path matches either TR or EN version
        if (endpoints.TR === basePath || endpoints.EN === basePath) {
            // Return the language-specific version with remaining path
            return endpoints[language] + remainingPath;
        }
    }

    // If no mapping found, return original path
    return path;
};

/**
 * Get endpoint by key
 * @param key - The endpoint key (e.g., 'HOME', 'PROPERTIES')
 * @param language - The target language
 * @returns The language-specific endpoint
 */
export const getEndpoint = (
    key: keyof typeof API_ENDPOINTS,
    language: Language
): string => {
    return API_ENDPOINTS[key][language];
};
